// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__3gRnq","body":"Modal_body__1Rkuc","icon":"Modal_icon__3oqYY","title":"Modal_title__StwnT","desc":"Modal_desc__1SaTN","btn":"Modal_btn__3xNcU"};